import React, { Component } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

export default class LoadingHR extends Component {
  render() {
    var currentLocation = window.location.pathname;
    let eLearningColorFlag = false;
    eLearningColorFlag = currentLocation.includes("/elearning/") ? true : false;
    return (
      //       <div className="loader"></div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "90vh",
        }}
      >
        {" "}
        <CircularProgress
          style={{ color: "rgba(0, 126, 99, 1)" }}
          // color={eLearningColorFlag ? "blue" : "secondary"}
        />
      </div>
    );
  }
}
